module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco-amazon-connect-chat-widget-4ef79328f48cf45066ab8fd05fa7bfa5.jpg";